<template>
    <div
        :class="classBannerSkinny"
        class="banner-skinny"
    >
        <div class="banner-skinny-wrapper">
            <ContentTitle :data="data.title" />
        </div>

        <div
            v-if="data.useBackgroundImage && data.backgroundImage"
            class="image-wrapper"
        >
            <CmsImage
                :data="data.backgroundImage"
                fit="cover"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ComponentBannerSkinnyFragment } from '@/graphql/api'
import type { ButtonColors } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'

import ContentTitle from '@/components/cms/component/content/ContentTitle.vue'
import CmsImage from '@/components/cms/CmsImage.vue'

const props = defineProps<{
    data: ComponentBannerSkinnyFragment
}>()

const backgroundColor = computed(
    (): ButtonColors => cmsColorToButtonColor(props.data.backgroundColor)
)

const classBannerSkinny = computed(
    () =>
        (!props.data.useBackgroundImage &&
            props.data.backgroundGraphic?.toLocaleLowerCase()) ||
        ''
)
</script>

<style lang="scss" scoped>
.banner-skinny {
    width: 100%;
    min-height: 220px;
    padding: 20px 0 0;
    position: relative;
    background: v-bind(backgroundColor);
    display: flex;
    align-items: center;

    &::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-size: auto 100%;
        background-position: center right;
        background-repeat: no-repeat;
        opacity: 0.2;
    }

    &.graphic1 {
        &::before {
            background-image: url('/src/assets/skinny-banner-graphic-1.png');
        }
    }

    &.graphic2 {
        &::before {
            background-image: url('/src/assets/skinny-banner-graphic-2.png');
        }
    }

    &.graphic3 {
        &::before {
            background-image: url('/src/assets/skinny-banner-graphic-3.png');
        }
    }

    &.graphic4 {
        &::before {
            background-image: url('/src/assets/skinny-banner-graphic-4.png');
        }
    }

    .banner-skinny-wrapper {
        width: 100%;
        padding: 0 20px;
        position: relative;
        z-index: 3;

        @include min-width(768) {
            padding: 0 40px;
        }
    }

    .image-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>
